import { render, staticRenderFns } from "./StockFailLog.vue?vue&type=template&id=87ac0cd4"
import script from "./StockFailLog.vue?vue&type=script&lang=js"
export * from "./StockFailLog.vue?vue&type=script&lang=js"
import style0 from "./StockFailLog.vue?vue&type=style&index=0&id=87ac0cd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports